export const SET_SELECTED_INDEX = "SET_SELECTED_INDEX";

export function setSelectedIndex(index) {
  return { type: SET_SELECTED_INDEX, payload: index };
}



// WEBPACK FOOTER //
// ./src/actions/quizResult.js